/*
 * NC · Entrega estimada del PDP. Calcula el rango en DÍAS HÁBILES (lunes a viernes) a partir de la fecha de hoy en la
 * zona horaria de la tienda (America/Mexico_City). Los días mínimo/máximo vienen de la sección (data-min / data-max), que
 * refleja la política de envío vigente (3 a 5 días hábiles). No hay corte horario documentado, así que no se inventa uno:
 * un pedido en sábado o domingo cuenta como lunes. No considera días festivos. Sin JS se ve el texto estático
 * "3 a 5 días hábiles".
 */
(function () {
  var el = document.querySelector('[data-nc-delivery]');
  if (!el) return;
  var out = el.querySelector('[data-nc-delivery-range]');
  var min = parseInt(el.getAttribute('data-min'), 10);
  var max = parseInt(el.getAttribute('data-max'), 10);
  if (!out || !(min > 0) || !(max >= min)) return;

  var TZ = 'America/Mexico_City';
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function todayInStoreZone() {
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var get = function (t) { return parseInt(parts.filter(function (p) { return p.type === t; })[0].value, 10); };
      return new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
    } catch (e) {
      var n = new Date();
      return new Date(Date.UTC(n.getFullYear(), n.getMonth(), n.getDate()));
    }
  }

  function addBusinessDays(start, n) {
    var d = new Date(start.getTime());
    var wd = d.getUTCDay();
    if (wd === 6) d.setUTCDate(d.getUTCDate() + 2);
    else if (wd === 0) d.setUTCDate(d.getUTCDate() + 1);
    while (n > 0) {
      d.setUTCDate(d.getUTCDate() + 1);
      wd = d.getUTCDay();
      if (wd !== 0 && wd !== 6) n--;
    }
    return d;
  }

  var today = todayInStoreZone();
  var a = addBusinessDays(today, min);
  var b = addBusinessDays(today, max);
  var da = a.getUTCDate(), db = b.getUTCDate(), ma = a.getUTCMonth(), mb = b.getUTCMonth();
  var text = ma === mb && a.getUTCFullYear() === b.getUTCFullYear()
    ? da + ' – ' + db + ' ' + MONTHS[mb]
    : da + ' ' + MONTHS[ma] + ' – ' + db + ' ' + MONTHS[mb];
  out.textContent = text;
  el.setAttribute('data-nc-delivery-ready', 'true');
})();
